import { jsPDF } from "jspdf";

const A4 = { w: 595, h: 842 };
const MARGIN = 48;
const NAVY = [27, 42, 78];
const GRAY = [75, 85, 99];
const WARNING = [224, 122, 95];

const fechaLarga = () =>
  new Date().toLocaleDateString("es-ES", { day: "numeric", month: "long", year: "numeric" });

const drawWatermark = (doc) => {
  doc.setFont("helvetica", "bold");
  doc.setFontSize(28);
  doc.setTextColor(232, 235, 238);
  for (let y = 120; y < A4.h; y += 130) {
    for (let x = -20; x < A4.w; x += 260) {
      doc.text("CONFIDENCIAL — USO INTERNO", x, y, { angle: 30 });
    }
  }
};

const renderBody = (doc, text, startY, { watermark = false } = {}) => {
  const width = A4.w - MARGIN * 2;
  const lines = doc.splitTextToSize(text || "", width);
  let y = startY;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(12);
  doc.setTextColor(17, 24, 39);
  lines.forEach((line) => {
    if (y > A4.h - 72) {
      doc.addPage();
      if (watermark) drawWatermark(doc);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(12);
      doc.setTextColor(17, 24, 39);
      y = 64;
    }
    doc.text(line, MARGIN, y);
    y += 18;
  });
};

const header = (doc, title, subtitle) => {
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.setTextColor(...NAVY);
  doc.text(title, MARGIN, 64);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.setTextColor(...GRAY);
  doc.text(subtitle, MARGIN, 86);
  doc.setDrawColor(42, 157, 159);
  doc.setLineWidth(1);
  doc.line(MARGIN, 96, A4.w - MARGIN, 96);
};

export const exportPatientPdf = (patientName, patientDoc) => {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  header(doc, "Documento para el paciente", `${patientName}  ·  ${fechaLarga()}`);
  renderBody(doc, patientDoc, 120);
  doc.setFontSize(9);
  doc.setTextColor(...WARNING);
  doc.text("PROTOTIPO — no usar con datos reales de pacientes", MARGIN, A4.h - 32);
  doc.save(`NotaViva_${patientName.replace(/\s+/g, "_")}.pdf`);
};

export const exportClinicalPdf = (patientName, clinicalRecord) => {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  drawWatermark(doc);
  header(doc, "Registro clínico interno", `${patientName}  ·  ${fechaLarga()}`);
  renderBody(doc, clinicalRecord, 120, { watermark: true });
  doc.setFontSize(9);
  doc.setTextColor(...WARNING);
  doc.text("CONFIDENCIAL — USO INTERNO  ·  PROTOTIPO — no usar con datos reales", MARGIN, A4.h - 32);
  doc.save(`NotaViva_CLINICO_${patientName.replace(/\s+/g, "_")}.pdf`);
};
